export default {
    culture: String, 
    decimals: Number, 
    downArrowText: String, 
    factor: Number, 
    format: String, 
    max: Number, 
    min: Number, 
    placeholder: String, 
    restrictDecimals: Boolean, 
    round: Boolean, 
    spinners: Boolean, 
    step: Number, 
    upArrowText: String, 
    value: Number, 

    // Events
    change: Function, 
    spin: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoNumericTextBox/NumericTextBoxProps.js